import { useState, useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import Button from 'aquilla/core/molecules/Button';
import Typography from 'aquilla/core/atoms/Typography';
import PropTypes from 'prop-types';
import Image from '@base/FutureImage';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import { segment } from '@actions/analytics';
import {
  ONBOARDING_GET_THE_APP_CLICKED,
  ONBOARDING_GET_THE_APP_BANNER_DISMISSED
} from '@cont/Onboarding/constants';
import useOneLinkSmartScriptV2 from '@hooks/useOneLinkSmartScriptV2';

const MobileLogo = 'Mobile-Logo.svg';
const close = 'k12/close-circle-filled.png';

const Container = styled.div`
  display: none;
  ${mediaQuery.uptoMobile} {
    display: flex;
    align-items: center;
    padding: 13px 8px 13px 16px;
    z-index: 4;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: var(--color-i-white);
    box-shadow: inset 0px 1px 0px var(--color-shadow);
    height: 66px;
  }
`;

const P = styled(Typography)`
  margin: 0 ${Spacings.SPACING_4B} 0 ${Spacings.SPACING_3B};
`;

const Download = styled(Button)`
  min-height: 32px;
  height: 32px;
  width: 91px;
  padding: 0;
  min-width: 91px;
  font-size: ${Fonts.SMALL};
  margin-right: ${Spacings.SPACING_4B};
`;

const CloseButton = styled.button`
  padding: 0;
  outline: 0;
  border: none;
  background: transparent;
`;

const AppInstallBanner = ({ pageType, downloadLink, goal = {} }) => {
  const {
    query: { goalUID, goalSlug }
  } = useRouter();
  const finalDownloadLink = useOneLinkSmartScriptV2() || downloadLink;
  const [load, setLoad] = useState(false);
  useEffect(() => {
    const homePageDownloadBanner = sessionStorage.getItem(pageType) ?? 0;
    const bannerValue = Number(homePageDownloadBanner);
    if (bannerValue === 0) {
      setLoad(true);
    }
  }, [pageType]);

  const installAppSegmentDetails = useMemo(
    () => ({
      goal_uid: goal?.uid || goalUID || 'NA',
      goal_name: goal?.name || goalSlug || 'NA',
      banner_position: 'Bottom Sticky',
      banner_name: 'Install Banner'
    }),
    [goal?.name, goal?.uid, goalSlug, goalUID]
  );

  const closeBanner = () => {
    segment.track(
      ONBOARDING_GET_THE_APP_BANNER_DISMISSED,
      installAppSegmentDetails
    );
    setLoad(false);
    sessionStorage.setItem(pageType, '1');
  };

  const downloadApp = () => {
    segment.track(ONBOARDING_GET_THE_APP_CLICKED, installAppSegmentDetails);
    window.open(finalDownloadLink, '_blank');
  };
  return load ? (
    <Container>
      <Image src={MobileLogo} width={36} height={36} alt="unacademy" />
      <P variant="p2">Get Free live classes & tests on the app</P>
      <Download
        size="small"
        variant="brand"
        onClick={downloadApp}
        label="Download"
      />
      <CloseButton onClick={closeBanner}>
        <Image src={close} width={20} height={20} alt="close" />
      </CloseButton>
    </Container>
  ) : null;
};

export default AppInstallBanner;

AppInstallBanner.propTypes = {
  pageType: PropTypes.string.isRequired,
  downloadLink: PropTypes.string.isRequired,
  goal: PropTypes.objectOf(PropTypes.any)
};

AppInstallBanner.defaultProps = {
  goal: {}
};
